module.exports = __webpack_public_path__ + "55b3e875f78d97a0a24b10f0f97708dd.png";